export const INSTITUCIONAL = {
  'atendimento': 'contact',
  'onde-encontrar': 'stores'
} 
